import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { Select, Store as NgxsStore } from '@ngxs/store';
import { OAuthService } from 'angular-oauth2-oidc';

import { CreateCommercialDocumentModalComponent } from '@app/shared/components/modals/create-commercial-document-modal/create-commercial-document-modal.component';
import { PurchasingProcedureModalComponent } from '@app/shared/components/modals/purchasing-procedure-modal/purchasing-procedure-modal.component';
import { CommercialDocumentProcessType } from '@app/pages/commercial-documents/components/commercial-document-list/enums/commercial-document-list.enum';
import { dropdownItems } from './constants';
import { DropdownItemType } from '@app/components/header/enums';
import { RoleName } from '@app/shared/enums/user.enum';
import { UserPopupMenuComponent } from '@app/components/header/components/user-popup-menu/user-popup-menu.component';
import { NotificationPanelComponent } from '@app/pages/notifications/components/notification-panel/notification-panel.component';
import { NotificationsStore } from '@app/pages/notifications/store/notifications.store';
import { ApplicationState } from '@app/_state/app.state';
import { ToggleMobileMenu, ToggleSidebarMenu } from '@app/_state/app.actions';
import { PrListStore } from '@app/pages/procurement/pr/pr-container/pr-list/store/pr-list.store';
import { CreatePrModalComponent } from '@app/pages/procurement/pr/pr-container/pr-list/components/create-pr-modal/create-pr-modal.component';
import { userRoles } from '@app/core/store/app.selectors';
import { CommunicationChartPanelComponent } from '@app/pages/constructor/constructor-components/communication-chart/components/communication-chart-panel/communication-chart-panel.component';
import { CommunicationChartPanelStore } from '@app/pages/constructor/constructor-components/communication-chart/store/communication-chart-panel.store';
import { MobileStateDirective } from '@app/shared/directives/mobile-state.directive';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  providers: [PrListStore],
  imports: [
    MatMenu,
    CommonModule,
    MatButton,
    MatMenuTrigger,
    MatMenuItem,
    UserPopupMenuComponent,
    MatIconButton,
    NotificationPanelComponent,
    UserPopupMenuComponent,
    TranslatePipe,
    CommunicationChartPanelComponent
  ]
})
export class HeaderComponent extends MobileStateDirective {
  @Select(ApplicationState.isOpenSidebarMenu)
  isOpenSidebarMenu$: Observable<boolean>;

  public userRoles$ = this.store.select(userRoles);
  public readonly notificationCountUnread$ =
    this.notificationsStore.notificationCountUnread$;
  public readonly commentsUnreadCount$ =
    this.communicationChartPanelStore.commentsUnreadCount$;

  public isOpenNotificationPanel = false;

  public readonly dropdownItems = dropdownItems;
  public readonly RoleName = RoleName;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private store: Store,
    private notificationsStore: NotificationsStore,
    private communicationChartPanelStore: CommunicationChartPanelStore,
    private ngxsStore: NgxsStore,
    public oAuthService: OAuthService
  ) {
    super();
  }

  @Select(ApplicationState.isOpenMobileMenu)
  isOpenMobileMenu$!: Observable<boolean>;
  public isOpenMessagePanel = false;

  public selectItem(type: DropdownItemType): void {
    switch (type) {
      case DropdownItemType.PR: {
        this.dialog.open(CreatePrModalComponent, {
          disableClose: true
        });
        break;
      }
      case DropdownItemType.TenderReduction: {
        this.dialog.open(PurchasingProcedureModalComponent);
        break;
      }
      case DropdownItemType.Agreement: {
        this.createCommercialDocument(CommercialDocumentProcessType.Agreement);
        break;
      }
      case DropdownItemType.Order: {
        this.createCommercialDocument(CommercialDocumentProcessType.Order);
        break;
      }
      case DropdownItemType.Receipt: {
        this.createCommercialDocument(CommercialDocumentProcessType.Receipt);
        break;
      }
    }
  }

  public toggleSidebarMenu(isOpen: boolean): void {
    this.ngxsStore.dispatch(new ToggleSidebarMenu(!isOpen));
  }

  public toggleMobileMenu(isOpen: boolean): void {
    this.ngxsStore.dispatch(new ToggleMobileMenu(!isOpen));
  }

  public openNotificationPanel(): void {
    this.isOpenNotificationPanel = true;
  }

  public openMessagePanel(): void {
    this.isOpenMessagePanel = true;
  }

  public navigateOnSomePage(url: '/signin' | '/signup'): void {
    this.router.navigate([url]);
  }

  public closeCommunicationChartPanel(): void {
    this.isOpenMessagePanel = false;
  }

  private createCommercialDocument(type: CommercialDocumentProcessType): void {
    this.dialog.open(CreateCommercialDocumentModalComponent, {
      data: {
        type
      }
    });
  }
}
